
import { createAsyncThunk } from "@reduxjs/toolkit";
import { acceptExtensionApi, acceptLinkApi, acceptOffer, acceptSubmitWorkApi, addReviewApi, askAdjustmentApi, buyPackPaymentApi, getChatList, getCurrentChatStageApi, getMessagesList, getMessagesListPaginated, getOfferPaymentPreview, getPendingCollaborationsCount, getUnreadMessageCount, makePaymentBrand, markSingleChatAsRead, rejectExtensionApi, rejectLinkApi, rejectOfferApi, releasePaymentToCreatorApi, reportIssueApi, sendCustomOfferApi, submitAppealApi, submitExtensionApi, submitLinkApi, submitWorkApi } from "api/chatApi";

import { updateMessageList } from "states/chat/chatSlice";

//
// import { getCurrentStageOfChat, markSingleChatAsReadApi } from "Common/Repository";


// Chat Action: Get Chats List
export const GetChatListApi = createAsyncThunk(
    "chat/list/get",
    async ({ header, data }, { rejectWithValue }) => {
        try {
            const response = await getChatList(header, data);
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// Chat Action: Get Messages List
export const GetMessagesListApi = createAsyncThunk(
    "messages/list/get",
    async ({ header, formData, dispatch, chat_id }, { rejectWithValue }) => {
        try {
            const response = await getMessagesList(header, formData, chat_id);
            dispatch(markSingleChatAsReadApi({ header, data: { chat_id } }));
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// Chat Action: Get Messages List Paginated
export const GetMessagesListPaginatedApi = createAsyncThunk(
    "messages/list/get/paginate",
    async ({ header, formData, dispatch, currentPage }, { rejectWithValue }) => {
        try {
            const response = await getMessagesListPaginated(header, formData, currentPage);
            dispatch(updateMessageList(response));
            return response;
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

// Chat Action: Accept Offer
export const AcceptOfferApi = createAsyncThunk(
    "messages/offer/accept",
    async ({ header, formData, dispatch, currentChatId }, { rejectWithValue }) => {
        try {
            const response = await acceptOffer(header, formData);
            // Dispatch the next action if needed
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);

// Chat Action: Get Unread Message Count
export const GetUnreadMessageCountApi = createAsyncThunk(
    "unread/messages/count",
    async ({ token }, { rejectWithValue }) => {
        try {
            const response = await getUnreadMessageCount(token);
            return response;
        } catch (error) {
            return rejectWithValue(error.response ? error.response.data : error);
        }
    }
);

// Chat Action: Buy Pack Payment Success
export const buyPackPaymentSuccessCall = createAsyncThunk(
    "messages/brand/payment",
    async ({ header, data, dispatch, currentChatId }, { rejectWithValue }) => {
        try {
            const response = await buyPackPaymentApi(header, data);
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error);
        }
    }
);

// Chat Action: Reject Offer
export const RejectOfferApi = createAsyncThunk(
    "messages/offer/reject",
    async ({ header, formData, dispatch, currentChatId }, { rejectWithValue }) => {
        try {
            const response = await rejectOfferApi(header, formData);
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error);
        }
    }
);

// Chat Action: Submit Work
export const SubmitWorkApi = createAsyncThunk(
    "messages/work/submit",
    async (
        { header, formData, dispatch, currentChatId, clear, setFilesToBeSent },
        { rejectWithValue }
    ) => {
        try {
            const response = await submitWorkApi(header, formData);
            if (response) {
                clear();
                setFilesToBeSent("");
            }
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error);
        }
    }
);

// Chat Action: Accept Submitted Work
export const AcceptSubmitWorkApi = createAsyncThunk(
    "messages/work/accept",
    async ({ header, formData, dispatch, currentChatId }, { rejectWithValue }) => {
        try {
            const response = await acceptSubmitWorkApi(header, formData);
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error);
        }
    }
);

// Chat Action: Ask For Adjustment
export const AskAdjustmentApi = createAsyncThunk(
    "messages/work/adjustment",
    async ({ header, formData, dispatch, currentChatId }, { rejectWithValue }) => {
        try {
            const response = await askAdjustmentApi(header, formData);
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error);
        }
    }
);

// Chat Action: Submit Link
export const SubmitLinkApi = createAsyncThunk(
    "messages/link/submit",
    async ({ header, formData, dispatch, currentChatId }, { rejectWithValue }) => {
        try {
            const response = await submitLinkApi(header, formData);
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error);
        }
    }
);

// Chat Action: Add Review
export const AddReviewApi = createAsyncThunk(
    "messages/add/review",
    async ({ header, formData, dispatch, currentChatId }, { rejectWithValue }) => {
        try {
            const response = await addReviewApi(header, formData);
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error);
        }
    }
);

// Chat Action: Accept Link
export const AcceptLinkApi = createAsyncThunk(
    "messages/link/accept",
    async ({ header, formData, dispatch, currentChatId }, { rejectWithValue }) => {
        try {
            const response = await acceptLinkApi(header, formData);
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error);
        }
    }
);

// Chat Action: Reject Link
export const RejectLinkApi = createAsyncThunk(
    "messages/link/reject",
    async ({ header, formData, dispatch, currentChatId }, { rejectWithValue }) => {
        try {
            const response = await rejectLinkApi(header, formData);
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            return rejectWithValue(error.response?.data || error);
        }
    }
);


// Chat Action: Report Issue
export const ReportIssueApi = createAsyncThunk(
    "messages/report",
    async (
        { header, formData, dispatch, currentChatId, clear, setSubmittingWork },
        { rejectWithValue }
    ) => {
        try {
            const response = await reportIssueApi(header, formData);  // Gọi hàm API
            if (response) {
                clear();
                setSubmittingWork("");
            }
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error);
            }
        }
    }
);

// Chat Action: Accept Extension
export const AcceptExtensionApi = createAsyncThunk(
    "messages/extension/accept",
    async (
        { header, formData, dispatch, currentChatId },
        { rejectWithValue }
    ) => {
        try {
            const response = await acceptExtensionApi(header, formData);  // Gọi hàm API
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error);
            }
        }
    }
);

// Chat Action: Reject Extension
export const RejectExtensionApi = createAsyncThunk(
    "messages/extension/reject",
    async (
        { header, formData, dispatch, currentChatId },
        { rejectWithValue }
    ) => {
        try {
            const response = await rejectExtensionApi(header, formData);  // Gọi hàm API
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error);
            }
        }
    }
);

// Chat Action: Submit Extension
export const SubmitExtensionApi = createAsyncThunk(
    "messages/extension/submit",
    async (
        { header, formData, dispatch, currentChatId },
        { rejectWithValue }
    ) => {
        try {
            const response = await submitExtensionApi(header, formData);  // Gọi hàm API
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error);
            }
        }
    }
);

// Chat Action: Send Custom Offer
export const SendCustomOfferApi = createAsyncThunk(
    "messages/offer/custom/send",
    async (
        { header, formData, dispatch, currentChatId },
        { rejectWithValue }
    ) => {
        try {
            const response = await sendCustomOfferApi(header, formData);  // Gọi hàm API
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error);
            }
        }
    }
);

// Chat Action: Submit Appeal
export const SubmitAppealApi = createAsyncThunk(
    "messages/appeal/create",
    async (
        { header, formData, dispatch, currentChatId, setDescription },
        { rejectWithValue }
    ) => {
        try {
            const response = await submitAppealApi(header, formData);  // Gọi hàm API
            if (response) {
                setDescription("");
            }
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error);
            }
        }
    }
);

// Chat Action: Get Current Chat Stage
export const getCurrentStageOfChat = createAsyncThunk(
    "currentChatStage/getCurrentChatStage",
    async ({ header, currentChatId }, { rejectWithValue }) => {
        try {
            const response = await getCurrentChatStageApi(header, currentChatId);  // Gọi hàm API
            return response;
        } catch (error) {
            // return custom error message from backend if present
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error);
            }
        }
    }
);

// Get Pending Collaborations Count
export const GetPendingCollaborationsCount = createAsyncThunk(
    "pending/collaboration/count",
    async ({ header, data }, { rejectWithValue }) => {
        try {
            const response = await getPendingCollaborationsCount(header, data); // Call the API function
            return response; // Return the response if successful
        } catch (error) {
            // Handle errors: check if error response exists and return custom error
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error); // Return the error if no response data
            }
        }
    }
);


// Mark single chat as read
export const markSingleChatAsReadApi = createAsyncThunk(
    "messages/single/read",
    async ({ header, data }, { rejectWithValue }) => {
        try {
            const response = await markSingleChatAsRead(header, data); // Call the API function
            return response; // Return the response on success
        } catch (error) {
            // Handle errors and pass custom error message from backend
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error); // Return the error if no response data
            }
        }
    }
);

// Make payment for the brand
export const MakePaymentBrand = createAsyncThunk(
    "messages/brand/payment",
    async (
        { header, formData, dispatch, currentChatId },
        { rejectWithValue }
    ) => {
        try {
            const response = await makePaymentBrand(header, formData); // Call the API function
            dispatch(getCurrentStageOfChat({ header, currentChatId })); // Dispatch another action to fetch current stage
            return response; // Return the response on success
        } catch (error) {
            // Handle errors and pass custom error message from backend
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error); // Return the error if no response data
            }
        }
    }
);


// Chat Action: Release Payment
export const ReleasePaymentToCreatorApi = createAsyncThunk(
    "messages/payment/release",
    async (
        { header, formData, dispatch, currentChatId },
        { rejectWithValue }
    ) => {
        try {
            const response = await releasePaymentToCreatorApi(header, formData);
            dispatch(getCurrentStageOfChat({ header, currentChatId }));
            return response;
        } catch (error) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            } else {
                return rejectWithValue(error);
            }
        }
    }
);

export const GetOfferPaymentPreviewApi = createAsyncThunk(
    "offer/paymentPreview",
    async ({ header, offerId }, { rejectWithValue }) => {
        try {
            const response = await getOfferPaymentPreview(header, offerId);
            return response.data; // trả về data JSON BE
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error
            );
        }
    }
);
